import { render } from "./bonusRoundView.vue?vue&type=template&id=34d8057b&scoped=true"
import script from "./bonusRoundView.vue?vue&type=script&lang=js"
export * from "./bonusRoundView.vue?vue&type=script&lang=js"

import "./bonusRoundView.vue?vue&type=style&index=0&id=34d8057b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d8057b"]])

export default __exports__